import React from "react";
import './Support.css';     // for Support.js
const Support = () => {
  return (
    <div className="support-container">
      <h2>Get Support Page</h2>
      {/* Support contact information */}
    </div>
  );
};

export default Support;
